var _dec, _dec2, _dec3, _class, _class2, _descriptor;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
import { Component, CustomElement, Prop, html } from '@sick-davinci/ce-decorators';
import { AccordionItem } from './accordion-item/AccordionItem';
import { style } from './Accordion.style';
/**
 * A `davinci-accordion` can be used to show and hide multiple rows of content.
 *
 * @example
 * ```html
 * <davinci-accordion multiple>
 *   <davinci-accordion-item label="Item 1">
 *   </davinci-accordion-item>
 *   <davinci-accordion-item label="Item 2">
 *     like the one above I'm also text
 *   </davinci-accordion-item>
 *   <davinci-accordion-item label="Item 3">
 *     yet again this is text
 *   </davinci-accordion-item>
 *   <davinci-accordion-item label="Item 4">
 *     oh look, more text
 *   </davinci-accordion-item>
 * </davinci-accordion>
 * ```
 * @slot {*} content of the accordion i.e. multiple `davinci-accordion-item`
 */

export let Accordion = (_dec = Component({
  tag: 'davinci-accordion',
  style: [style],
  dependencies: [AccordionItem]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = class Accordion extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "multiple", _descriptor, this);
  }

  /**
   * is called from an AccordionItem if the open state was changed
   */
  informOfOpenStateChange(accordionItem) {
    if (accordionItem.open) {
      this._lastOpenedItem = accordionItem;
    }

    this._checkMultipleState();
  }

  render() {
    this._checkMultipleState();

    return html`
      <slot @slotchange='${this._checkMultipleState}'></slot>
    `;
  }

  _checkMultipleState() {
    const accordionItems = Array.from(this.querySelectorAll('davinci-accordion-item'));

    if (!this.multiple) {
      accordionItems.forEach(ai => {
        if (!this._lastOpenedItem && ai.open) {
          // set initial state on first static render
          this._lastOpenedItem = ai;
        }

        if (ai !== this._lastOpenedItem) {
          ai.open = false;
        }
      });
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "multiple", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
